import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export function usePageview() {
  const location = useLocation();
  const prev = useRef(null);

  useEffect(() => {
    const path = location.pathname;
    if (path === prev.current) return;
    prev.current = path;

    axios.post(`${API}/api/analytics/pageview`, { page: path }).catch(() => {});
  }, [location.pathname]);
}
